const rewards_en = require('./rewards.json')
export default rewards_en